const encodeSegment = (value) => encodeURIComponent(String(value || '').trim());

export const RECORD_ROUTE_PATTERNS = Object.freeze({
  index: '/records',
  video: '/records/videos/:videoId',
  release: '/records/releases/:releaseId',
  legacy: '/records/:legacyId',
});

export const recordVideoRoute = (videoId) => (
  `/records/videos/${encodeSegment(videoId)}`
);

export const recordReleaseRoute = (releaseId) => (
  `/records/releases/${encodeSegment(releaseId)}`
);
